import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import momentPropTypes from 'react-moment-proptypes';
import PostalOperatorSelectionSidebarContainer
  from '../../target-node-mrd-impc-selector/containers/PostalOperatorSelectionSidebarContainer';
import ProgressButtons from './ProgressButtons';
import {
  getDepartureCheckedMailProcessingCenters,
  getDeparturePostalOperators,
  getExpandedDeparturePostalOperators,
  getSelectedDeparturePostalOperators,
} from '../../target-node-mrd-impc-selector/redux/selectors/PostalOperatorSelectors';
import SaveIMPCSelectionModal from '../../target-node-mrd-impc-selector/components/SaveIMPCSelectionModal';
import { saveUserMrdImpcSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import PostalOperatorSelector from '../../target-node-mrd-impc-selector/components/PostalOperatorSelector';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../period-selector/redux/selectors/PeriodSelectionSelectors';
import {
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpanded, onDeSelectAllDepartureMailProcessingCenters,
  onSelectAllDepartureMailProcessingCenters,
  retrieveOutboundPostalOperatorsRequestActionCreator,
} from '../../target-node-mrd-impc-selector/redux/actions/DeparturePostalOperatorActions';
import { setDirections } from '../../target-node-mrd-impc-selector/redux/actions/PostalOperatorActions';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import * as LocationTypes from '../../../common/redux/actions/types/LocationTypes';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
// eslint-disable-next-line import/no-cycle
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import noop from "../../../../core/modules/common/tools/noop";
import { createPresetSelectionsOnSave } from "../../../react-table/helpers/utils";

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsRequestActionCreator,
  saveUserMrdImpcSelectionRequestActionCreator,
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpanded,
  onSelectAllDepartureMailProcessingCenters,
  onDeSelectAllDepartureMailProcessingCenters,
  setDirections,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureCheckedMailProcessingCenters: getDepartureCheckedMailProcessingCenters(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperators(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
});

// eslint-disable-next-line react/prefer-stateless-function
class TargetNodeMrdImpcWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstDeparture: true,
      departureSelectionTreeLoaded: false,
      showOnlySelectedDeparturePostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedMailProcessingCenters: [],
      saveSelectionSelections: [],
    };
  }

  componentDidMount() {
    this.props.setDirections({
      directions: this.props.children.report.reportDirections,
    });

    this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: this.props.children.report.reportDirections[0],
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      },
      this.props.children.report,
      this.props.departureCheckedMailProcessingCenters,
    );
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedDeparturePostalOperatorsNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstDeparture && this.props.departurePostalOperatorsNodes === nextProps.departurePostalOperatorsNodes && nextProps.selectedDeparturePostalOperatorsNodes.length !== 0) {
      this.setState({
        firstDeparture: false,
        showOnlySelectedDeparturePostalOperators: true,
      });
    }

    await this.props.departurePostalOperatorsNodes;
    this.setState({
      departureSelectionTreeLoaded: this.props.departurePostalOperatorsNodes.length > 0,
    });
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureMailProcessingCenters(this.props.departurePostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureMailProcessingCenters();
  };

  onSelectDeparturePostalOperatorOrImpc = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    } else {
      this.setState({
        firstDeparture: false,
      });
    }
    this.props.departureMailProcessingCenterCheckedActionCreator(selected, this.props.children.report);
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(this.props.departureCheckedMailProcessingCenters, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
    });
  };

  openSaveSelectionModal = ({ checkedMailProcessingCenters, selections }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedMailProcessingCenters: checkedMailProcessingCenters,
      saveSelectionSelections: selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedMailProcessingCenters }) => {
    this.props.saveUserMrdImpcSelectionRequestActionCreator(
      name,
      checkedMailProcessingCenters,
    );
    this.closeSaveSelectionModal();
  };

  render() {
    const tempDepartureNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.departureCheckedMailProcessingCenters && this.props.departureCheckedMailProcessingCenters.length > 0 ?
          this.props.departureCheckedMailProcessingCenters.map(initialItem => ({ value: initialItem, label: '' })) : [],
      }];

    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedMailProcessingCenters,
      expanded: !this.state.departureSelectionTreeLoaded ? [] : this.props.departureExpandedPostalOperators,
      expandDisabled: !this.state.departureSelectionTreeLoaded ? true : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.departureSelectionTreeLoaded ? true : this.state.showOnlySelectedDeparturePostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.departureSelectionTreeLoaded ? tempDepartureNodes : this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: !this.state.departureSelectionTreeLoaded ? tempDepartureNodes : this.props.departurePostalOperatorsNodes,
      onSelect: !this.state.departureSelectionTreeLoaded ? noop : this.onSelectDeparturePostalOperatorOrImpc,
      onExpand: !this.state.departureSelectionTreeLoaded ? noop : this.onExpandDeparturePostalOperator,
      onSelectAll: !this.state.departureSelectionTreeLoaded ? noop : this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: !this.state.departureSelectionTreeLoaded ? noop : this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: !this.state.departureSelectionTreeLoaded ? noop : this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: !this.state.departureSelectionTreeLoaded ? noop : this.openSaveSelectionModalForDeparture,
    };

    const selectionCriteria = this.props.children.report.selectionCriteria.items;
    const SC_CODE = sc.SC080;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        {this.state.showSaveSelectionModal &&
        <SaveIMPCSelectionModal
          saveSelection={this.saveSelection}
          closeModal={this.closeSaveSelectionModal}
          checkedMailProcessingCenters={this.state.saveSelectionCheckedMailProcessingCenters}
          selections={this.state.saveSelectionSelections}
        />
        }
        <div className="operator-sidebar">
          <PostalOperatorSelectionSidebarContainer
            operatorType={OperatorTypes.DEPARTURE}
            operators={departurePostalOperatorSelectorProps.originalPostalOperatorNodes}
            report={this.props.children.report}
          />
        </div>

        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <PostalOperatorSelector
                title="MRD IMPC"
                {...departurePostalOperatorSelectorProps}
              />
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>);
  }
}

TargetNodeMrdImpcWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundPostalOperatorsRequestActionCreator: PropTypes.func,
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  saveUserMrdImpcSelectionRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpanded: PropTypes.func,
  onSelectAllDepartureMailProcessingCenters: PropTypes.func,
  onDeSelectAllDepartureMailProcessingCenters: PropTypes.func,
  setDirections: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeMrdImpcWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetNodeMrdImpcWizardContainer);

export default (ConnectedTargetNodeMrdImpcWizardContainer);
